module.exports = __webpack_public_path__ + "img/vertical_3_3_9006.6ad2e86a.png";